import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import {Button, Form, Input, Select} from "antd";
import RequestTypeSelectBox from "../request-type/RequestTypeSelectBox";
import ReportEditor from "../../core/components/ReportEditor";
import ModalitySelectBox from "../modality/ModalitySelectBox";
import ApiService from "../../core/service/api-service";
import StudyTypeEnum from "../../enums/StudyTypeEnum";

const defaultReportContent = {
    Teknik: 'Teknik',
    Karsilastirma: 'Karsilastirma',
    SonucVeOneriler: 'SonucVeOneriler',
    Bulgular: 'Bulgular'
}

export default function ReportTemplateCreateEditForm({reportTemplateId})
{
    const {t} = useTranslation()
    const formRef = useRef();

    const [defaultTemplateContent, setDefaultTemplateContent] = useState(defaultReportContent);
    const [templateId, setTemplateId] = useState(reportTemplateId || null);
    const template = useRef({})
    const actualRequestTypeId = useRef(null)

    const getReportTemplate = async () => {
        if (!templateId || templateId <= 0) return;

        const res = await ApiService.ReportTemplate.Get(templateId);
        if (res.success) {
            actualRequestTypeId.current = res.data.requestTypeId;
            formRef.current.setFieldsValue({
                name: res.data.name,
                modalityId: res.data.requestType.modality.name,
                requestTypeId: res.data.requestType.name,
                language: res.data.language,
                studyType: res.data.studyType,
            });
            await getReportTemplateFileData(templateId);
        }
    }

    const getReportTemplateFileData = async (id) => {
        const res = await ApiService.ReportTemplate.GetReportTemplateFileData(id);
        setDefaultTemplateContent(JSON.parse(res.data))
        template.current = JSON.parse(res.data)
    }

    const save = async (form) => {
        const data = { ...form, content: template.current };
        if (templateId) {
            await ApiService.ReportTemplate.Edit(templateId, data);
        } else {
            const res = await ApiService.ReportTemplate.Create(data);
            if (res.success) setTemplateId(res.data);
        }
    }

    useEffect(() => {
        getReportTemplate()
    }, [templateId])

    useEffect(() => {
        setTemplateId(reportTemplateId || null)
    }, [reportTemplateId]);

    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                layout={'vertical'}
                onFinish={save}
                autoComplete="off"
            >
                <Form.Item
                    label={t('Name')}
                    name="name"
                    rules={[{ required: true, message: t('Please input report template name!') }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Language')}
                    name="language"
                    rules={[{ required: false }]}
                >
                    <Select placeholder={t('Select Language')} allowClear>
                        <Select.Option value="tr">Türkçe</Select.Option>
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="de">Deutsch</Select.Option>
                        <Select.Option value="fr">Français</Select.Option>
                        <Select.Option value="es">Español</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="requestTypeId" label={t('Request Type')} rules={[{ required: true }]}>
                    <RequestTypeSelectBox
                        disabled={!!templateId}
                        onChange={(requestId) => {
                            actualRequestTypeId.current = requestId
                        }}
                        onOptionsLoaded={() => {
                            
                        }}
                    />
                </Form.Item>

                <Form.Item name="studyType" label={t('Study Type')} rules={[{ required: false }]}>
                    <Select placeholder={t('Select Study Type')} allowClear>
                        <Select.Option value={StudyTypeEnum.ROUTINE}>{t('Routine')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.INPATIENT}>{t('Inpatient')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.EMERGENCY}>{t('Emergency')}</Select.Option>
                        <Select.Option value={StudyTypeEnum.COMPARATIVE_EXAMINATION}>{t('Comparative Examination')}</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item>
                    <ReportEditor
                        defaultReportContent={defaultTemplateContent}
                        onBulgular={(data) => { template.current = { ...template.current, Bulgular: data } }}
                        onSonuc={(data) => { template.current = { ...template.current, SonucVeOneriler: data } }}
                        onKarsilastirma={(data) => { template.current = { ...template.current, Karsilastirma: data } }}
                        onTeknik={(data) => { template.current = { ...template.current, Teknik: data } }}
                    />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
